// extracted by mini-css-extract-plugin
export default {"description__anchor":"advicesl6iqaF","description__headline":"advicesRodQLu","description__subline":"advicesYfRnKl","advice":"advicestb249P","picture":"advices8CPlRU"};